export default __webpack_public_path__ + "static/media/brand_htco_visual02.eb0ac344.jpg";